export default __webpack_public_path__ + "static/media/icon-ng.ca82396a.svg";